import React from "react";
import C5Agradecimientos from "../content/Agradecimientos";
import C0Portada from "../content/Portada";
import C1Nosotros from "../content/C1Nosotros";
import C2Periodismo from "../content/C2Periodismo";
import C3Educacion from "../content/C3Educacion";
import C4Otros from "../content/C4Otros";
import { Helmet } from "react-helmet";

const home = () => {
  return (
    <div className="home">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Memoria 2014-2024 - Fundación Gustavo Mohme Llona</title>
        <meta
          property="og:title"
          content="Memoria 2014-2024 - Fundación Gustavo Mohme Llona"
        />
      </Helmet>
      <C0Portada />
      <C1Nosotros />
      <C2Periodismo />
      <C3Educacion />
      <C4Otros />
      <C5Agradecimientos />
    </div>
  );
};

export default home;
